import React, {Component} from 'react';

import styled from 'styled-components';
import {connect} from 'react-redux'
import ConfirmationPopup from "./ConfirmationPopup";

import {apiFetchCarModelDetailsPayment, apiFetchCountdown, apiSubmitPayment} from "../../apis/calculator";

import QR from "./payment/QR.jpg"
import moment from 'moment'
import ReactPixel from 'react-facebook-pixel';

const NoneFound = styled.div`
  width: 100%;
  height: 100%;

  div {
    width: 100%;
    padding: 10px;
    text-align: center;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);

    font-size: 25px;
    font-weight: bold;
  }

  span {
    @media (min-width: 1000px) {
      display: block;
    }
  }
`;

class Confirmation extends Component {
    state = {
        deposit: '',
        file: null,
        showPopup: false,
        popupTxt: '',
        success: false,
        preview: '',
        refId: '',
        netPrice: '',
        remarks: '',
        error: false,
        countdown: 0,
        countdownStart: false,
        prod: false
    }

    handlePopup = () => {
        const val = this.state.showPopup;
        this.setState({
            showPopup: !val
        })
        this.props.history.push('/')
    }

    componentDidMount() {
        if (window.location.href.includes("online-sales.mazda.com.sg")) {
            ReactPixel.init('273792070524054');
            ReactPixel.pageView();

            this.setState({
                prod: true
            })
          }

        window.scroll({
            top: 0, 
            left: 0, 
            behavior: 'smooth'
          });
          
        apiFetchCarModelDetailsPayment(this.props.match.params.id).then((res)=>{
            const data = res.carModelDetailList[0].colorList[0].trimList[0].optionList[0].carModelList[0],
             deposit = data.deposit,
             refId = data.refId,
             netPrice = data.nettPrice
           this.setState({
               deposit,
               refId,
               netPrice
           })
          }).catch((e)=>{
              this.setState({
                  error: true
              })
              console.log(e)
        });

        

        apiFetchCountdown().then((res) => {
            this.setState({
                countdown: res * 60 * 1000,
                countdownStart: true
            }, () => {
                this.startTimer();
            })
        }).catch((e) => {
            console.log(e)
        });


    }

    countDown = () => {
        let countdown = this.state.countdown - 1000;
        this.setState({
          countdown,
        });

        if (countdown === 0) { 
          clearInterval(this.timer);
          this.onRedirect();
        }
      }

    startTimer = () => {
        if (this.state.countdownStart === true && this.state.countdown > 0) {
          this.timer = setInterval(this.countDown, 1000);
        }
      }

    

    componentWillUnmount = () => {
        clearInterval(this.timer)
    }

    onRedirect = () => {
        this.setState({
            showPopup: true
        })
    }


    onDone = () => {
        ReactPixel.track('Lead');
        let remarks = this.state.remarks;

        if (remarks) {
            remarks = remarks.replace(/(?:\r\n|\r|\n)/g, '\\n')
        }

        const params = {
            carModelId: this.props.match.params.id,
            paymentRemark: remarks
        }
        apiSubmitPayment(params).then((res)=>{
            this.props.history.push('/thank')
          }).catch((e)=>{
              console.log(e)
        });
    }

    onFileUpload = (e) => {
        
        const file = e.target.files[0];

        const reader = new FileReader();
        const url = reader.readAsDataURL(file);

        reader.onloadend = function (e) {
            this.setState({
                preview: reader.result
            }, () => {
                this.setState({
                    file
                })
            });
        }.bind(this);



    }

    onDownload = () => {
        const element = document.createElement("a");
        const file = new Blob(
        [
            "http://3.1.200.54/mbfjwebadmin/uploadFiles/20190516_034114_file.jpg"
        ],
        { type: "image/*" }
        );
        element.href = URL.createObjectURL(file);
        element.download = "image.jpg";
        element.click();
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }


    render() {
       
        const { className } = this.props;
        const state = this.state;

        if (state.error) {
            return <NoneFound>
            <div>
            System encountered an error. Please retry later.
            </div>
            </NoneFound>
        }
        
        return <div className={className}>
            {
                state.prod ? <img border="0" style={{width: 0, height: 0, position: "absolute"}} src="https://r.turn.com/r/beacon?b2=qqa3gpWDnH82HccdFl0r5IxqiYjpUaLSlDxAHq3eCxOzNPlUFo4chDo95bs8J6m4LNC7Or4X7ATQJrsH2Y1PiA&cid=" /> : ''
            }
            <div className="nav-container">
                    <div className="nav-wrap">
                        <div className="nav-no">1</div>
                        <div className="nav-txt">Financial calculator</div>
                    </div>
                    <div className="nav-wrap">
                        <div className="nav-no">2</div>
                        <div className="nav-txt">Customer Information</div>
                    </div>
                    <div className="nav-wrap active">
                        <div className="nav-no">3</div>
                        <div className="nav-txt">Payment</div>
                    </div>
                </div>
            <div className='wrapper'>
                
                <div className="payment-thank">
                    Make Payment for Reservation
                </div>

                <div className="netPrice-wrap">
                    Nett Price <span className="netPrice-price">${state.netPrice ? state.netPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","): ''}</span>
                </div>
                {/* <div className="payment-title">Make payment for Deposit</div> */}
                {/* <div className="payment-subtitle">Please make payment using the PayNow QR Code below</div> */}
                <div className="payment-deposit-wrap">
                    <div className="payment-deposit-label">Refundable Reservation Fee</div>
                    <div className="payment-deposit-price">${state.deposit ? state.deposit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","): ''}</div>
                </div>
                {/* <div className="payment-refund">
                    (This reservation fee is fully refundable)
                </div> */}

               <div className="qr-txt">
                    Please make payment using the PayNow QR Code below. 
               </div>
               <img src={QR} className="qr-img" alt="QR Code" />
                <a href={QR} download className="qr-download">
                    Download QR Code Image
                </a>
                <div className="payment-uen">
                    <br />
                    OR <br />
                    UEN: 199103859NTMZ
                </div>
                {/* <div className="qr-bank-container">
                    <div className="qr-bank-wrap">
                        <a href="https://www.sc.com/sg/bank-with-us/paynow/" target="_blank">
                            <img src={Bank1} className="qr-bank" alt="" />
                        </a>
                    </div>
                    <div className="qr-bank-wrap">
                        <a href="https://www.dbs.com.sg/personal/deposits/pay-with-ease/paynow" target="_blank">
                            <img src={Bank2} className="qr-bank" alt="" />
                        </a>
                    </div>
                    <div className="qr-bank-wrap">
                        <a href="https://www.ocbc.com/personal-banking/digital-banking/paynow.page?gclid=EAIaIQobChMI3YOn0ofR6QIV8Z7CCh36FwjEEAAYASAAEgIfcvD_BwE&cid=onlinebanking:PayNow:Tactical-Acquisition:Apr2020:sem:google:ocbc%20paynow:Generic:Prospecting:Expanded-Text-Ad:Desktop&ef_id=EAIaIQobChMI3YOn0ofR6QIV8Z7CCh36FwjEEAAYASAAEgIfcvD_BwE:G:s&s_kwcid=AL!990!3!435648839921!e!!g!!ocbc%20paynow&gclsrc=aw.ds" target="_blank">
                            <img src={Bank3} className="qr-bank" alt="" />
                        </a>
                    </div>
                    <div className="qr-bank-wrap">
                        <a href="https://www.maybank-ke.com.sg/latest-offerings/listing/paynow-with-us/" target="_blank">
                            <img src={Bank4} className="qr-bank" alt="" />
                        </a>
                    </div>
                    <div className="qr-bank-wrap last">
                        <a href="https://www.uob.com.sg/personal/eservices/ebanking/paynow.page" target="_blank">
                            <img src={Bank5} className="qr-bank" alt="" />
                        </a>
                    </div>
                </div> */}
                <div className="remarks-label">PayNow Reference Number</div>
                <textarea placeholder="Please enter the last 6 digit of the PayNow transaction reference here." className="remarks-input" onChange={this.handleChange} name="remarks" value={this.state.remarks}></textarea>
                <div className="payment-approve">
                Once the payment is approved, our Sales Consultant will contact you to complete the Vehicle Sales Agreement.
                </div>
                <div className="payment-btn-wrap">
                    <button disabled={!this.state.remarks} className="payment-btn-done" onClick={this.state.remarks ? this.onDone : null}>
                        Complete Reservation
                    </button>
                </div>
                <div className="payment-warning">
                    Please complete reservation in: 
                    <div className="payment-timer">
                        { 
                            moment(state.countdown).utc().format('mm:ss')
                        }
                    </div>
                </div>
            </div>
            {this.state.showPopup ? 
                            <ConfirmationPopup
                                text={<div className="confirmTxt">
                                        <p> The session has timed out. <br />Click OK to return to main page.</p>
                                        <button onClick={this.handlePopup} className="btn btn-primary popbtn"> OK </button>
                                        
                                    </div>}
                                // closePopup={this.togglePopup.bind(this)}
                            />
                            : null
                    }
        </div>;
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        ...state.calculator,
        context: state.context,
        calculator: state.calculator,
        email: state.form
    };
};

const mapDispatchToProps = dispatch => {
    return {
        async onSubmit() { 
            // const result = await dispatch(submit());
            // console.log('onSubmit:result: ', result);
        }
           
        
    }
};

const ConnectedConfirmation = connect(
    mapStateToProps,
    mapDispatchToProps
)(Confirmation);

let StyledConfirmation = styled(ConnectedConfirmation)`
width: 100%;

.payment-uen {
    letter-spacing: 0.2em;
    font-weight: bold;
    line-height: 1.75;
}

.nav-container {
    text-align: center;
}

.remarks-label {
    margin-top: 25px;
    color: #101010;
    font-weight: bold;
    font-size: 18px;
    letter-spacing: 2.7px;
    text-transform: uppercase;
}
.payment-approve {
    color: #999999;
    font-style: italic;
    font-family: MazdaM;
    font-size: 14px;
    margin-top: 30px;
}
.remarks-input {
    appearance: none;
    outline: 0;

    box-sizing: border-box;

    border: 1px solid #707070;
    padding: 10px 15px;
    width: 100%;
    height: 84px;
}
.qr-bank-container {
    margin-top: 20px;
}

.qr-bank {
    width: 80px;
    display: inline-block;
}
.qr-bank-wrap {
    display: inline-block;
    margin-right: 12px;
    margin-bottom: 5px;

    &.last {
        margin-right: 0;
    }
}

.qr-img {
    display: block;
    margin: 0 auto;
    width: 200px;
}
.qr-download {
    text-decoration: none;
    color: #9C0000;
    font-size: 15px;
    margin-bottom: 20px;
}
.qr-txt {
    font-size: 15px;
    margin-top: 30px;
}
.payment-refund {
    color: #999999;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 1.8px;
    text-transform: uppercase;
}
.nav-wrap {
    display: inline-block;
    margin-top: 19px;
    margin-bottom: 23px;
    
    .nav-txt {
        display: inline-block;
        margin-right: 30px;
        line-height: 20px;
        vertical-align: middle;
        color: #999999;
        font-size: 13px;

        @media (max-width: 420px) {
            margin-right: 15px;
            font-size: 11px;
        }
    }
    .nav-no {
        display: inline-block;
        font-size: 13px;
        color: #FFF;
        background-color: #999999;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 3px;
        line-height: 20px;
    }

    &.active .nav-txt {
        color: #101010;
    }

    &.active .nav-no {
        background-color: #890000;
    }
}
.wrapper{
    max-width: 450px;
    padding: 5px 25px;
    margin: 25px auto; 
    text-align: center;
    margin-top: 0;

    @media (min-width: 1000px) {
        max-width: 450;
        padding-left: 0;
        padding-right: 0; 
    }
}
.btnLabel {
    color: #BBB;
    font-size: 0.8rem;
}
.payment-thank {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 3px;
    text-transform: uppercase;
}

.payment-timer {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 3px;
    text-transform: uppercase;
    display: inline-block;
    background-color: #212529;
    color: #FFF;
    padding: 5px;
    border-radius: 5px;
    margin-left: 15px;
}

.payment-warning {
    text-align: left;
    font-weight: bold;
    color: red;
    margin-top: 5px;
    margin-bottom: 20px;
    font-size: 18px;
}

.netPrice-wrap {
    margin-top: 20px;
    margin-bottom: 8px;
    font-weight: bold;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 1.8px;
}
.netPrice-price {
    font-size: 17px;
    letter-spacing: 2.55px;
}
.payment-title {
    font-weight: bold;
    font-size: 1.2rem;
    margin: 1rem 0 2rem 0;
}
.payment-subtitle {
    font-weight: bold;
    font-size: 1.2rem;
}
.payment-deposit-wrap {
    padding: 10px;
    margin-top: 5px;
    margin-bottom: 5px;
    border: 1px solid #DDDDDD;

    .payment-deposit-label {
        color: #AAA;
        text-transform: uppercase;
        letter-spacing: 1.2px;
    }
    .payment-deposit-price {
        color: #890000;
        letter-spacing: 2.55px;
        font-size: 17px;
    }
}
.payment-approved {
    font-weight: bold;
    font-size: 1.2rem;
}
.payment-qr-wrap {

    margin: 20px 0;

    .payment-qr-image {
        width: 250px;
        height: 250px;
    }
    .payment-qr-txt, .payment-qr-txt:hover {
        text-decoration: none;
        margin-top: 0.5rem;
        color: #1DAEED;
        font-size: 1.2rem;
        cursor: pointer;
        display: block;
    }
}
.payment-preview {
    display: inline-block;
    margin-top: 10px;
    margin-bottom: 10px;
    max-width: 450px;
}
.payment-instructions-wrap {
    text-align: left;
    margin-top: 20px;

    ol {
        padding-left: 15px;
    }

    li {
        list-style-type: decimal;
        margin-bottom: 15px;
    }
}
.payment-instructions-title {
    font-weight: bold;
    font-size: 1.2rem;
    text-decoration: underline;
    margin-bottom: 20px;
}
.list-highlight {
    text-decoration; underline;
    font-weight: bold;
    font-size: 1.1rem;
}
.list-ref {
    font-weight: bold;
    margin-left: 20px;
    font-size: 1.1rem;
}
.payment-btn-wrap {
    max-width: 450px;
    margin: 0 auto;
}
.payment-btn-upload {
    display: inline-block;
    background-color: #1DAEED;
    color: #FFF;
    font-size: 18px;
    border-radius: 0;
    text-align: center;
    line-height: 48px;
    height: 48px;
    width: 100%;
    cursor: pointer;
}
.payment-btn-done {
    display: inline-block;
    background-color: #0F0F0F;
    color: #FFF;
    font-size: 13px;
    letter-spacing: 1.95px;
    text-transform: uppercase;
    font-weight: bold;
    border-radius: 0;
    text-align: center;
    line-height: 60px;
    height: 60px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    cursor: pointer;

    &:disabled {
        opacity: 0.5;
        cursor: initial;
    }
}
.payment-success {
    border: 1px solid #EEF5E5;
    color: #47763D;
    text-align: center;
    padding: 15px;
    background-color: #E1F0D8;
    margin-bottom: 15px;
}
`;

export default StyledConfirmation


// WEBPACK FOOTER //
// ./src/components/configurator/Payment.js